import { render, staticRenderFns } from "./DD_Notifications.vue?vue&type=template&id=0fbb04bc&scoped=true&"
import script from "./DD_Notifications.vue?vue&type=script&lang=js&"
export * from "./DD_Notifications.vue?vue&type=script&lang=js&"
import style0 from "./DD_Notifications.vue?vue&type=style&index=0&id=0fbb04bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbb04bc",
  null
  
)

export default component.exports